import { render, staticRenderFns } from "./PaperDetailList.vue?vue&type=template&id=5269b2d7&scoped=true"
import script from "./PaperDetailList.vue?vue&type=script&lang=js"
export * from "./PaperDetailList.vue?vue&type=script&lang=js"
import style0 from "./PaperDetailList.vue?vue&type=style&index=0&id=5269b2d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5269b2d7",
  null
  
)

export default component.exports